defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Faq/FaqItem',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    var FaqItem = {
      controller: function ({ controller, item, index }) {
        Object.assign(this, controller);

        this.item = item;
        this.index = index;
        this.isActive = () => {
          return this.openedItemIndex() === index;
        };

        this.toggleOpenedItem = () => {
          const newIndex = this.isActive() ? null : index;
          this.openedItemIndex(newIndex);
        };

        this.setHeight = ($elem, ignore, context) => {
          if (!this.isActive()) {
            return $elem.style.maxHeight = null;
          }
          if (!context.innerheight) {
            context.innerheight = $elem.querySelector('.play-together-faq__item-content-inner').clientHeight;
          }

          $elem.style.maxHeight = `${context.innerheight}px`;
        };
      },
      view: function (controller) {
        return m('.play-together-faq__item', {
          class: controller.isActive() ? 'play-together-faq__item--active' : ''
        }, [
          m('.play-together-faq__item-header', {
            onclick: controller.toggleOpenedItem
          }, [
            m('.play-together-faq__item-title', controller.item.question),
            m('svg.play-together-faq__item-arrow', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow'
            }))
          ]),
          m('.play-together-faq__item-content-wrapper', {
            config: controller.setHeight
          },
          m('.play-together-faq__item-content-inner', m.trust(controller.item.answer))
          )
        ]);
      }
    };

    // Public functions:
    return FaqItem;
  });
